(function () {
  'use strict';

  function escapeHtml(value) {
    var node = document.createElement('div');
    node.textContent = value || '';
    return node.innerHTML;
  }

  function cleanReviewCopy(value) {
    return String(value || '')
      .replace(/[\u2018\u2019]/g, "'")
      .replace(/[\u201C\u201D]/g, '"')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function formatReviewSummary(average, count) {
    return average.toFixed(1) + ' · ' + count + ' reviews';
  }

  function buildJudgeMeUrl(shopDomain, publicToken, productId, page, perPage) {
    var url = new URL('https://cdn.judge.me/reviews/reviews_for_widget');
    url.searchParams.set('platform', 'shopify');
    url.searchParams.set('shop_domain', shopDomain);
    url.searchParams.set('product_id', productId);
    url.searchParams.set('page', String(page || 1));
    url.searchParams.set('per_page', String(perPage || 10));
    if (publicToken) {
      url.searchParams.set('public_token', publicToken);
    }
    return url.toString();
  }

  function buildStarString(rating) {
    return '★'.repeat(rating) + '☆'.repeat(5 - rating);
  }

  function bindFeaturedCarousel(section) {
    var track = section.querySelector('#featured-review-track');
    if (!track || track.dataset.boundFeaturedCarousel) return;
    track.dataset.boundFeaturedCarousel = 'true';
    section.querySelectorAll('[data-featured-arrow]').forEach(function (button) {
      button.addEventListener('click', function () {
        var direction = button.getAttribute('data-featured-arrow') === 'next' ? 1 : -1;
        track.scrollBy({ left: direction * Math.max(track.clientWidth * 0.85, 320), behavior: 'smooth' });
      });
    });
  }

  function initJudgeMe(section) {
    var mount = section.querySelector('[data-judge-me-widget]');
    var stars = section.querySelector('.pwt-review-summary__stars');
    var summary = section.querySelector('.pwt-review-summary__text');
    if (!mount || !stars || !summary) return;

    var state = {
      reviewPage: 1,
      reviewPageSize: 10,
      judgeMeData: null,
      observer: null
    };

    var shopDomain = section.getAttribute('data-judge-me-shop-domain') || '';
    var publicToken = section.getAttribute('data-judge-me-public-token') || '';
    var productId = mount.getAttribute('data-review-product-id') || '';

    function renderSummary(data) {
      var average = Number((data && data.average_rating) || 0);
      var count = Number((data && data.number_of_reviews) || 0);
      if (!count) {
        stars.textContent = '☆☆☆☆☆';
        summary.textContent = 'No reviews yet';
        return;
      }
      var rounded = Math.max(0, Math.min(5, Math.round(average)));
      stars.textContent = buildStarString(rounded);
      summary.textContent = formatReviewSummary(average, count);
    }

    function renderReviewCard(item) {
      var name = escapeHtml(item.reviewer_name || item.reviewer_initial || 'Customer');
      var body = item.body_html || (item.body ? '<p>' + escapeHtml(cleanReviewCopy(item.body)) + '</p>' : '');
      var created = item.created_at ? new Date(item.created_at).toLocaleDateString('en-US') : '';
      var rating = Math.max(0, Math.min(5, Math.round(Number(item.rating || 5))));
      return (
        '<article class="pdp-review-card">' +
        '<div class="pdp-review-card-stars">' + buildStarString(rating) + '</div>' +
        '<div class="pdp-review-card-body">' + body + '</div>' +
        '<div class="pdp-review-card-head"><strong>' + name + '</strong><span>' + escapeHtml(created) + '</span></div>' +
        '</article>'
      );
    }

    function renderPagination(totalCount) {
      var totalPages = Math.max(1, Math.ceil(totalCount / state.reviewPageSize));
      if (totalPages <= 1) return '';
      return (
        '<div class="pdp-review-pagination">' +
        '<button class="pdp-review-pagination__nav" type="button" data-review-page-nav="prev"' + (state.reviewPage === 1 ? ' disabled' : '') + '>Previous</button>' +
        '<div class="pdp-review-pagination__status">Page ' + state.reviewPage + ' of ' + totalPages + '</div>' +
        '<button class="pdp-review-pagination__nav" type="button" data-review-page-nav="next"' + (state.reviewPage === totalPages ? ' disabled' : '') + '>Next</button>' +
        '</div>'
      );
    }

    function renderWidget(data) {
      var loading = section.querySelector('#judgeme-reviews-loading');
      if (loading) loading.style.display = 'none';

      var items = Array.isArray(data && data.reviews) ? data.reviews : [];
      if (!items.length) {
        mount.innerHTML = '<p class="pdp-reviews-empty">No reviews yet.</p>';
        return;
      }

      var photoWall = Array.isArray(data && data.photo_gallery)
        ? data.photo_gallery.flatMap(function (item) {
            return (item.pictures_urls || []).slice(0, 1).map(function (pic) {
              return '<img src="' + escapeHtml(pic.original || pic.small || pic.compact || '') + '" alt="Customer review photo" loading="lazy">';
            });
          }).slice(0, 8)
        : [];

      mount.innerHTML =
        (photoWall.length
          ? '<div class="pdp-review-photos-wall">' + photoWall.join('') + '</div>'
          : '') +
        '<div class="pdp-review-list">' +
        items.map(renderReviewCard).join('') +
        '</div>' +
        renderPagination(Number(data && data.number_of_reviews || items.length));
    }

    async function loadReviews(immediate) {
      if (!productId) {
        renderSummary(null);
        mount.innerHTML = '<p class="pdp-reviews-empty">No reviews yet.</p>';
        return;
      }

      async function fetchAndRender() {
        try {
          var response = await fetch(buildJudgeMeUrl(shopDomain, publicToken, productId, state.reviewPage, state.reviewPageSize));
          if (!response.ok) throw new Error('Judge.me reviews fetch failed');
          var data = await response.json();
          state.judgeMeData = data;
          renderSummary(data);
          renderWidget(data);
        } catch (error) {
          console.error(error);
          state.judgeMeData = null;
          renderSummary(null);
          summary.textContent = 'Reviews unavailable';
          mount.innerHTML = '<p class="pdp-reviews-empty">Reviews unavailable right now.</p>';
        }
      }

      if (immediate) {
        fetchAndRender();
        return;
      }

      if (state.observer) {
        state.observer.disconnect();
      }

      state.observer = new IntersectionObserver(function (entries) {
        if (entries[0] && entries[0].isIntersecting) {
          state.observer.disconnect();
          fetchAndRender();
        }
      }, { rootMargin: '320px' });

      state.observer.observe(mount);
      fetchAndRender();
    }

    if (!mount.dataset.boundReviewPagination) {
      mount.dataset.boundReviewPagination = 'true';
      mount.addEventListener('click', function (event) {
        var navButton = event.target.closest('[data-review-page-nav]');
        if (!navButton || !state.judgeMeData) return;
        var totalCount = Number((state.judgeMeData && state.judgeMeData.number_of_reviews) || 0);
        var totalPages = Math.max(1, Math.ceil(totalCount / state.reviewPageSize));
        state.reviewPage = Math.max(
          1,
          Math.min(totalPages, state.reviewPage + (navButton.getAttribute('data-review-page-nav') === 'next' ? 1 : -1))
        );
        loadReviews(true);
      });
    }

    loadReviews(false);
  }

  function init() {
    document.querySelectorAll('[data-wizard-test-section]').forEach(function (section) {
      bindFeaturedCarousel(section);
      initJudgeMe(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
